export class DialogModelLogisticsSessions {
    constructor(
      public data: any
    ) {}
  }